






import Vue from 'vue';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSettingStore from '@/containers/cv-setting/store';
import EditContainer from '@/containers/cv-setting/edit.vue';

const fetch = async params => {
  const { cv_id } = params;
  await store.dispatch(CvSettingStore.GetCv.namespaced({ cv_id }));
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSettingStore],
    };
  },
});
